module.exports = __webpack_public_path__ + "img/nick.692c263b.png";